class TransformToTitleCase {
  static filter(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word[0].toUpperCase() + word.substr(1))
      .join(' ');
  }
}

export default TransformToTitleCase.filter;




// WEBPACK FOOTER //
// ./src/filters/title-case.filter.js